export default __webpack_public_path__ + "static/media/en.f4f4d2df.svg";